export const inlineStyleSeparator = (text, ranges) => {

	const styleDictionary = { BOLD: 1, ITALIC: 2, UNDERLINE: 4 };

	// reformats range input into an array.
	// eg: [{offset: 1, length: 5, style: 'BOLD'}] --> [[1, 5, 1]]
	const newStyles = ranges.map( item => [item.offset, item.length, styleDictionary[item.style]]);
	
	// spread the text into an array of individual characters with style '0'.
	// eg: 'Hi' becomes [['H', 0], ['i',0]]
	let textArray = Array.from(text, item => [item, 0]);
	let breaks = [];

	// for each style, add it to each character in range,
	// and push the start and end character of the style into a list of break points.
	newStyles.forEach( range => {
		const [start, length, style] = range;
		const end = start + length;

		breaks.push(start);
		breaks.push(end);

		for (let i = start; i < end; i++) {
			textArray[i][1] += style;
		}
	});
	
	// add the beginning and the end character to the list.
	breaks.push(0);
	breaks.push(text.length);
	breaks.sort((a, b) => a - b);

	let segments = [];
	
 	// get the text and the style for each range between break points.
 	// eg: imagine the break points are [0, 1, 6, 13], therefore grab the text between 0-1, 1-6 and 6-10,
 	// 	   and the corresponding style of each range
	breaks.forEach(( item, index, array ) => {
		const nextItem = array[index + 1]

		// if the current item is the last or if it's a repeat, skip it.
		if (index === array.length -1) return;
		if (item === nextItem) return;

		segments.push({
			text: text.slice(item, nextItem),
			style: textArray[item][1],
			key: `b:${item}e:${nextItem}`,
		});
	});
	
	return segments;
}
